import React, { Component } from 'react';
import './App.css';

import FullScreen from 'react-full-screen';

import MapContainer from './components/MapContainer';
import axios from 'axios';
import Loader from './components/Loader';
import FullScreenButton from './components/FullScreenButton';

// import { Loader, Dimmer, Segment } from 'semantic-ui-react';

class App extends Component {
  state = {
    data: false,
    loaded: false,
    fullscreen: false,
    mpIframe: null
  };
  constructor(props) {
    super(props);

    this.getData = this.getData.bind(this);
    this.onMPLoad = this.onMPLoad.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  async getData() {
    console.log('getData()');
    try {
      const { data } = await axios.get(`${process.env.PUBLIC_URL}/config.json`);
      this.setState({ data });
      return true;
    } catch (e) {
      console.log(`could not get data from ${process.env.PUBLIC_URL}`, e);
    }
  }

  onMPLoad(mpIframe) {
    console.log('loaded scene');
    this.setState({ loaded: true });
  }

  render() {
    return (
      <div className="App">
        <FullScreen
          enabled={this.state.fullscreen}
          onChange={fullscreen => this.setState({ fullscreen })}
        >
          {this.state.data && (
            <MapContainer
              className="full-screenable-node"
              fullscreen={this.state.fullscreen}
              onChangeFullscreen={fullscreen => this.setState({ fullscreen })}
              onLoad={this.onMPLoad}
              data={this.state.data}
            />
          )}
          {!this.state.loaded && <Loader />}
        </FullScreen>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js